import { Flex } from 'antd';

interface BankDetailsSectionsLayoutProps {
  children: React.ReactNode;
}

export function BankDetailsSectionsLayout({ children }: BankDetailsSectionsLayoutProps) {
  return (
    <Flex vertical gap={12} className='w-full'>
      {children}
    </Flex>
  );
}
